// import flatpickr from "flatpickr";

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const options = {
      enableTime: true,
      dateFormat: "Y-m-d H:i",
      locale: this.element.dataset.locale || 'en',
      time_24hr: true
    }

    if (this.element.value) options['defaultDate'] = this.element.value
    flatpickr(this.element, options);
  }
}
